<template>
  <ppt-slide-viewer module-code="xsq_jm" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "XsqJm",
  components: { PptSlideViewer }
};
</script>
